module.exports = __webpack_public_path__ + "f2f968de6f6579d28fa0b0ddedc57fc0.svg";